import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'permissionCheck',
})
export class PermissionCheckPipe implements PipeTransform {

  public RIGHT = {
    CREATE : '[A-Z]*[C][A-Z]*',
    READ : '[A-Z]*[R][A-Z]*',
    UPDATE : '[A-Z]*[U][A-Z]*',
    DELETE : '[A-Z]*[D][A-Z]*'
    }

  public MOD = {
    URD :'^(URD)[.]',
    SFD :'^(SFD)[.]',
    BILL :'^(BILL)[.]',
    PMT :'^(PMT)[.]',
    MTR :'^(MTR)[.]',
    COM :'^(COM)[.]',
    SMS :'^(SMS)[.]',
    NTC :'^(NTC)[.]',
    MSG :'^(MSG)[.]',
    DSB :'^(DSB)[.]',
    PRF :'^(PRF)[.]',
    ACL :'^(ACL)[.]',
    STG :'^(STG)[.]',
    URG :'^(URG)[.]',
    VMS :'^(VMS)[.]',
    ICH :'^(ICH)[.]',
    TRF :'^(TRF)[.]',
    BCYL :'^(BCYL)[.]',
    CSR :'^(CSR)[.]',
    ASNCOM :'^(ASNCOM)[.]',
    COMJC :'^(COMJC)[.]',
    TFRCOM :'^(TFRCOM)[.]',
    OBT :'^(OBT)[.]',
    UACT :'^(UACT)[.]',
    MTRRDG :'^(MTRRDG)[.]',
    CHKBNC :'^(CHKBNC)[.]',
    ORGSTR :'^(ORGSTR)[.]',
    EML :'^(EML)[.]',
    GNP :'^(GNP)[.]',
    MKTPLC:'^(MKTPLC)[.]',
    VMSSTF :'^(VMSSTF)[.]',
    BLRPT :'^(BLRPT)[.]',
    BLNRPT :'^(BLNRPT)[.]',
    CMRPT :'^(CMRPT)[.]',
    ADVCH:'^(ADVCH)[.]',
    DBTCRT:'^(DBTCRT)[.]',
    CHQPRK:'^(CHQPRK)[.]',
    DOC :'^(DOC)[.]',
    FBK :'^(FBK)[.]',
    FAC :'^(FAC)[.]',
    FMB :'^(FMB)[.]',
    ISMSTF :'^(ISMSTF)[.]',
    NTFSTG :'^(NTFSTG)[.]',
    SUSPND:'^(SUSPND)[.]',
    GENSER:'^(GENSER)[.]',
    EXPUSR:'^(EXPUSR)[.]',
    BILPRO:'^(BILPRO)[.]',
    BILTYP:'^(BILTYP)[.]',
    BILTYPUSR:'^(BILTYPUSR)[.]',
    MTRACT:'^(MTRACT)[.]',
    IER:'^(IER)[.]',
    DSBCHRT:'^(DSBCHRT)[.]',
    ACONT:'^(ACONT)[.]',
    TARNS:'^(TARNS)[.]',
    TRRPT:'^(TRRPT)[.]',
    COMESC:'^(COMESC)[.]',
    SAPACC:'^(SAPACC)[.]',
    CHPW:'^(CHPW)[.]',
    USRDTL:'^(USRDTL)[.]',
    SEQ:'^(SEQ)[.]',
    TMP:'^(TMP)[.]',
    CANPMT:'^(CANPMT)[.]',
    CANBIL:'^(CANBIL)[.]',
    RESDSB:'^(RESDSB)[.]',
    TENMGT:'^(TENMGT)[.]',
    PNC:'^(PNC)[.]',
    FRZ:'^(FRZ)[.]',
    CUSRPT:'^(CUSRPT)[.]',
    APPR:'^(APPR)[.]',
    COMREP:'^(COMREP)[.]',
    COMVSTTM:'^(COMVSTTM)[.]',
    MYSOC:'^(MYSOC)[.]',
    PDFREGEN:'^(PDFREGEN)[.]',
    ADVTS:'^(ADVTS)[.]',
    CRPMT:'^(CRPMT)[.]',
    DRPMT:'^(DRPMT)[.]',
    PMTREQ:'^(PMTREQ)[.]',
    CUSREM:'^(CUSREM)[.]',
    PMTRECON:'^(PMTRECON)[.]',
    UNITREM:'^(UNITREM)[.]',
    OUTSND:'^(OUTSND)[.]',
    BILLAGE:'^(BILLAGE)[.]',
    PPM:'^(PPM)[.]',
    PPMTSK:'^(PPMTSK)[.]',
    PPMASST:'^(PPMASST)[.]',
    PPMRDG:'^(PPMRDG)[.]',
    PPMALRT:'^(PPMALRT)[.]',
    INVT:'^(INVT)[.]',
    COMSUBOTH:'^(COMSUBOTH)[.]',
    RESHOMAWY:'^(RESHOMAWY)[.]',
    AOACOM:'^(AOACOM)[.]',
    COMFRCCLS:'^(COMFRCCLS)[.]',
    SURVEY: '^(SURVEY)[.]',
    VEH: '^(VEH)[.]',
    MPN: '^(MPN)[.]',
    IVRDIS:'^(IVRDIS)[.]',
    UAT : '^(UAT)[.]',
    GSTPRK: '^(GSTPRK)[.]',
    REFR:'^(REFR)[.]',
    VMSPAS:'^(VMSPAS)[.]',
    EVNT:'^(EVNT)[.]',
    MTRBAL:'^(MTRBAL)[.]',
    VHCLNO:'^(VHCLNO)[.]'
  }

  transform(input: string, type: string, per: string) {
    let regex = `${this.MOD[type]}+${this.RIGHT[per]}`;
    if(input && regex){
      var patt = new RegExp(regex);
      for (var i = 0; i < input.length; i++) {
        if (patt.test(input[i]))
          return true;
      }}
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/permission-check/permission-check.ts